import { Pencil1Icon } from "@radix-ui/react-icons";
import { Row, Table } from "@tanstack/react-table";
import { useState } from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog/alert-dialog";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select/select";

import { Input } from "@/components/ui/input/input";

import { HalfDay } from "./schema";

interface UpdateRowModalProps<TData> {
  row: Row<TData>;
  table: Table<TData>;
}

export const UpdateRowModal = <TData,>({
  row,
  table,
}: UpdateRowModalProps<TData>) => {
  const originData = row.original as HalfDay;

  const [rowData, setRowData] = useState<{
    dayOfWeek: number;
    minimumHours: number;
  }>(() => originData);

  const [open, setOpen] = useState(false);

  return (
    <>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogTrigger>
          <span className="cursor-pointer transition-all duration-300">
            <Pencil1Icon className="w-6 h-6 transition-all duration-300 p-1 hover:bg-ring/10 rounded-full" />
          </span>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Update Row</AlertDialogTitle>
          </AlertDialogHeader>

          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <label htmlFor="dayOfWeek">Day of Week</label>
              <Select
                value={String(rowData.dayOfWeek)}
                onValueChange={(value) => {
                  // field.onChange(Number(value));
                  setRowData((prev) => {
                    return {
                      ...prev,
                      dayOfWeek: Number(value),
                    };
                  });
                }}
              >
                <SelectTrigger className="">
                  <SelectValue placeholder="Weekly Day" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="0">Sunday</SelectItem>
                  <SelectItem value="1">Monday</SelectItem>
                  <SelectItem value="2">Tuesday</SelectItem>
                  <SelectItem value="3">Wednesday</SelectItem>
                  <SelectItem value="4">Thursday</SelectItem>
                  <SelectItem value="5">Friday</SelectItem>
                  <SelectItem value="6">Saturday</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="minimumHours">Minimum Hours</label>
              <Input
                id="minimumHours"
                name="minimumHours"
                value={rowData.minimumHours}
                type="number"
                onChange={(e) => {
                  setRowData((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: Number(e.target.value),
                    };
                  });
                }}
              />
            </div>
          </div>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // @ts-ignore
                table.options.meta?.updateRow(row.index, rowData);

                setOpen(false);
              }}
            >
              Continue
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
